$(document).ready(function() {

    setTimeout(function() {
        $('.addOnWrapper').css('opacity', 1);
    }, 3000);

    const checkbox = document.getElementById('addonProductCheckbox');
    const button = document.querySelector('.combo-btn');


    // Combo toggle: "Add" / "Added" plus a status line naming the tartan the roll will be made in
    function renderComboState() {
        if (!checkbox || !button) return;
        const on = checkbox.checked;
        const tartan = comboTartan().name;
        button.classList.toggle('is-added', on);
        button.querySelector('.text').textContent = on ? 'Added' : 'Add';
        button.querySelector('.plusIcon').style.display = on ? 'none' : 'block';
        button.querySelector('.addonAddedIcon').style.display = on ? 'block' : 'none';
        const status = document.getElementById('comboStatus');
        if (status) {
            status.textContent = !on ? '' : tartan
                ? 'Added with your watch, in ' + tartan + '.'
                : 'Added. Choose your tartan and the roll will match it.';
        }
        comboMessage('');
    }

    if (checkbox && button) {
        checkbox.addEventListener('change', () => {
            renderComboState();
            // Adding the roll before a tartan is chosen leads straight to the picker
            if (checkbox.checked && !comboTartan().name) {
                const picker = document.getElementById('tartanSelectorBtn');
                if (picker) picker.click();
            }
        });
        document.addEventListener('tartan:change', renderComboState);
    }
    // Combo roll: copies the watch's tartan and pairs roll + watch under one hidden "Watch N" label,
    // so each roll in a multi-watch cart stays matched to its own watch.
    function comboTartan() {
        const name = document.getElementById('selectedTartan');
        const image = document.getElementById('selectedTartanImage');
        return { name: name ? name.value.trim() : '', image: image ? image.value : '' };
    }

    function comboMessage(text) {
        let msg = document.getElementById('comboTartanMessage');
        if (!msg) {
            msg = document.createElement('p');
            msg.id = 'comboTartanMessage';
            msg.setAttribute('role', 'alert');
            msg.style.cssText = 'color:#b42318;font-size:14px;margin:8px 0 0;';
            $('.customButton').after(msg);
        }
        msg.textContent = text;
    }

    function setWatchLabel(label) {
        const form = $('.orgButtonWrap').closest('form')[0];
        if (!form) return;
        $(form).find('input[name="properties[_Set]"]').remove();
        if (!label) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_Set]';
        input.value = label;
        form.appendChild(input);
    }

    $(document).on('click', '.customButton', function(e) {
        const addonVariantId = $('#addonProductCheckbox:checked').data('addon-variant-id');
        const tartan = comboTartan();
        comboMessage('');
        setWatchLabel('');
        // The watch is made in the customer's tartan: no tartan, nothing reaches the cart.
        // The picker's own submit check is bypassed because this button adds through the app/AJAX route.
        if (window.tartanSelector && !window.tartanSelector.validateSelection()) {
            const picker = document.getElementById('tartanSelectorBtn');
            if (picker) picker.focus({ preventScroll: true });
            return;
        }
        // The combo roll needs the watch's tartan; stop before anything reaches the cart
        if (addonVariantId && !tartan.name) {
            comboMessage('Choose your tartan first, so your watch roll is made to match.');
            const picker = document.getElementById('tartanSelectorBtn');
            if (picker) {
                picker.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
                picker.focus({ preventScroll: true });
            }
            return;
        }
        if (addonVariantId) {
            $.getJSON('/cart.js').then(function(cart) {
                // "_Set" is hidden from customers (cart, checkout) but kept on the order for fulfilment
                const sets = cart.items.filter(function(item) { return item.properties && item.properties._Set; })
                    .map(function(item) { return item.properties._Set; });
                const label = 'Watch ' + (new Set(sets).size + 1);
                setWatchLabel(label);
                const properties = { 'Tartan Name': tartan.name, '_Set': label };
                if (tartan.image) properties['Tartan Image'] = tartan.image;
                addCombo(properties);
            }, function() {
                addCombo({ 'Tartan Name': tartan.name });
            });
            return;
        }
        clickOriginalButton();

        function addCombo(properties) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({
                    items: [{
                        id: addonVariantId,
                        quantity: 1,
                        properties: properties
                    }]
                }),
                dataType: 'json',
                contentType: 'application/json',
                beforeSend: function() {
                    $(".combo-btn .plusIcon").hide();
                    $(".combo-btn .addonAddedIcon").hide();
                    $(".combo-btn .loaderIcon").show();
                },
                success: function(response) {
                    // console.log('Addon added:', response);
                    $(".combo-btn .loaderIcon").hide();
                    setTimeout(function() {
                        // $(".ctForm form").submit();
                        let gpoButton = document.querySelector(".gpo-clone-atc-button");
                        if(gpoButton){
                            $(".orgButtonWrap .gpo-clone-atc-button").click();
                        }
                        else{
                            $(".orgButtonWrap button").click();
                        }
                        $(".combo-btn .addonAddedIcon").show();
                    }, 1000);
                    // Optional: show confirmation message
                    // alert('Addon product added!');
                },
                error: function(error) {
                    $(".combo-btn .loaderIcon").hide();
                    $(".combo-btn .addonAddedIcon").show();
                    setWatchLabel('');
                    comboMessage('The watch roll could not be added. Please try again.');
                    console.error('Addon add failed:', error);
                }
            });
        }

        function clickOriginalButton() {
            setTimeout(function() {
                let gpoButton = document.querySelector(".gpo-clone-atc-button");
                if(gpoButton){
                    $(".orgButtonWrap .gpo-clone-atc-button").click();
                }
                else{
                    $(".orgButtonWrap button").click();
                }
            }, 1000);
        }
    });
    // When "Add to Cart" button clicked

});